import { createContext, useContext } from 'react'
import { stripLanguagePrefix } from '../../i18n/translate/routing.js'

// Marketing pages are also rendered to static HTML at build time
// (scripts/postbuild-marketing.mjs renders them with react-dom/server), so
// crawlers that don't run JavaScript read the same copy people see. During
// that render there is no window: the page being built is passed in here
// instead. In the browser the context is always null.
export type MarketingPrerender = {
  pathname: string
  search: string
  hostname: string
}

export const MarketingPrerenderContext = createContext<MarketingPrerender | null>(null)

export function useMarketingPrerender() {
  return useContext(MarketingPrerenderContext)
}

// The address of the page being shown: the browser's, or the page being built.
// Translated pages (/de/pricing/) are the same page as /pricing/.
export function useCurrentPathname() {
  const prerender = useContext(MarketingPrerenderContext)
  if (prerender) return prerender.pathname
  return typeof window === 'undefined' ? '/' : stripLanguagePrefix(window.location.pathname)
}

export function useCurrentSearch() {
  const prerender = useContext(MarketingPrerenderContext)
  if (prerender) return prerender.search
  return typeof window === 'undefined' ? '' : window.location.search
}

export function useCurrentHostname() {
  const prerender = useContext(MarketingPrerenderContext)
  if (prerender) return prerender.hostname
  return typeof window === 'undefined' ? '' : window.location.hostname
}
